// Reusable centered loading state: the animated brand spinner + Hebrew text.
// Use for full-view waits (initial data load); pass a title and optional sub-text.
function Loader({title = "טוען...", text}) {
    return (
        <div className="app-loader">
            <div className="loadeing" role="status" aria-label="טוען"></div>
            <h5 className="app-loader-title">{title}</h5>
            {text ? <p className="app-loader-text">{text}</p> : null}
        </div>
    );
}

export default Loader;
